import dayjs from "dayjs";

export const QUESTIONS = [
  {
    id: "name",
    questionType: "Short answer",
    minNAnswers: 1,
    requestField: null,
  },
  {
    id: "surname",
    questionType: "Short answer",
    minNAnswers: 1,
    requestField: null,
  },
  {
    id: "phone",
    questionType: "Short answer",
    minNAnswers: 1,
    requestField: "welfarePhone",
  },
  {
    id: "email",
    questionType: "Short answer",
    minNAnswers: 1,
    requestField: "welfareEmail",
  },
  {
    id: "email-repeat",
    questionType: "Short answer",
    minNAnswers: 1,
    requestField: "welfareEmail",
  },
  {
    id: "privacy",
    questionType: "Checkboxes",
    minNAnswers: 1,
    answers: [
      {
        id: "privacy-text",
      },
    ],
    requestField: null,
  },
];

export const getQuestionLabel = (questionId, labels) => {
  return labels?.[`WELFARE_OSTEOPATA_SURVEY_${questionId.toUpperCase()}`] || questionId;
};

export const parseRequest = (request, userProfile) => {
  if (request?.editMode) {
    const formData = Object.fromEntries(QUESTIONS?.map((q) => [q.id, request?.[q.requestField]]));
    formData.name = userProfile.firstName;
    formData.surname = userProfile.lastName;
    formData.privacy = true;

    return {
      formData,
      requestOsteopath: request.osteopath,
      requestBooking: dayjs(Number(request?.bookingDate)),
    };
  } else return { formData: {}, requestOsteopath: null, requestBooking: null };
};
